export default window.$;
